// extracted by mini-css-extract-plugin
export default {"reviewItem":"ReviewItemCard_reviewItem__+kxj0"};